import React from 'react';

function NotParticipatedResultContentSP({ viewModel }) {
  const { all } = viewModel;

  return (
    <div style={{ padding: '10px' }}>
      <h3>あなたの結果</h3>
      <div style={{ marginBottom: '10px' }}>このラウンドには参加していません。</div>

      <h3>的中した選択肢</h3>
      <div>的中はありませんでした。</div>

      <hr style={{ margin: '16px 0' }} />

      <h3>全体データ（参考）</h3>
      <div>参加者数: {all.participantsCount ?? '-'} 人</div>
      {all.topResult && (
        <div>最高配当者:  {all.topResult.name}（{all.topResult.totalRefund} pt）</div>
      )}
    </div>
  );
}

export default NotParticipatedResultContentSP;
